module.exports = __webpack_public_path__ + "img/debtPayingAbility2.3c52d976.png";